import { createFileRoute, notFound } from "@tanstack/react-router";
import { OrdbogTermPage, OrdbogTermNotFound, ordbogTermHead } from "@/pages/OrdbogTermPage";
import { findTermBySlug } from "@/data/ordbog";

export const Route = createFileRoute("/viden/$slug")({
  loader: ({ params }) => {
    const term = findTermBySlug(params.slug);
    if (!term) throw notFound();
    return { term };
  },
  head: ({ loaderData }) =>
    loaderData
      ? ordbogTermHead(loaderData.term, "da")
      : { meta: [{ title: "Viden | MI Support" }] },
  notFoundComponent: () => <OrdbogTermNotFound locale="da" />,
  component: RouteComponent,
});

function RouteComponent() {
  const { term } = Route.useLoaderData();
  return <OrdbogTermPage term={term} locale="da" />;
}
